import { render, staticRenderFns } from "./InputForm.vue?vue&type=template&id=fe5a4418&scoped=true&"
import script from "./InputForm.vue?vue&type=script&lang=js&"
export * from "./InputForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5a4418",
  null
  
)

export default component.exports